import { MutationTree } from "vuex";
import { IUser, UserState } from "@/types/user";
import { User } from "@/models/user";
import { removeCookie } from "tiny-cookie";

const mutations: MutationTree<UserState> = {
  set: (state, data: IUser) => {
    state.single = new User(data);
  },
  clearUser: (state) => {
    state.single = new User();
  },
  clearToken: () => {
    removeCookie("access_token");
  },
  clearRole: (state) => {
    state.abilities = "";
  },
  abilities: (state, abilities: string) => {
    state.abilities = abilities;
  },
};

export default mutations;
